import type { PaymentFormAddressInterface, PaymentFormInterface } from './types';

export const MAX_ADYEN_EXPIRATION_YEAR = 30;

export const ADYEN_INVALID_MESSAGE = 'Invalid card details, try again';

export const FORMIK_INVALID_MESSAGE = 'Please review the errors below';

export const DEFAULT_ADDRESS_FORM_STATE: PaymentFormAddressInterface = {
    streetAddress: '',
    apt: '',
    zipCode: '',
    state: '',
    city: '',
};

export const DEFAULT_PAYMENT_FORM_STATE: PaymentFormInterface = {
    addressType: 'form',
    firstName: undefined,
    lastName: undefined,
    phone: undefined,
    nameOnCard: '',
    expirationDate: '',
    address: DEFAULT_ADDRESS_FORM_STATE,
    selectedAddressId: null,
    isPrimary: false,
};

export const CARD_TOKENIZATION_REJECTED_MESSAGE = 'Credit Card tokenization is rejected by psp';
export const CARD_REJECTED_MESSAGE = 'Could not add card';
export const PAYMENT_PROCESSOR_ERROR_MESSAGE = '[BFF] Error reaching payment processor';
